module.exports = __webpack_public_path__ + "img/internet.ccdb34cd.svg";